import { render } from "./DocumentFieldIcon.vue?vue&type=template&id=313f20a2&scoped=true"
import script from "./DocumentFieldIcon.vue?vue&type=script&lang=js"
export * from "./DocumentFieldIcon.vue?vue&type=script&lang=js"

import "./DocumentFieldIcon.vue?vue&type=style&index=0&id=313f20a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313f20a2"]])

export default __exports__